import { OG_DEFAULT_META, resolveOgMeta } from "@/router/ogMeta";
import { headInstance } from "@/utils/headInstance";

let currentTitle = OG_DEFAULT_META.title;
let currentDescription = OG_DEFAULT_META.description;
const pageMetadataEntry = headInstance.push({
  title: currentTitle,
  meta: [{ name: "description", content: currentDescription }],
});

function patchPageMetadata() {
  pageMetadataEntry.patch({
    title: currentTitle,
    meta: [{ name: "description", content: currentDescription }],
  });
}

export function setPageMetadata(path: string, title: string) {
  currentTitle = title;
  currentDescription = resolveOgMeta(path).description;
  patchPageMetadata();
}

export function setPageTitle(title: string) {
  currentTitle = title;
  patchPageMetadata();
}
